/**
 * Helpers for displaying contact form submissions in VIVA HUB
 */

export const CONTACT_SOURCE_LABELS = {
  contact_page: 'Contact Us',
  book_session: 'Book a Session',
  resources_page: 'Resources Page',
}

const LANGUAGE_LABELS = {
  en: 'English',
  pt: 'Portuguese',
}

/** Flat list of { label, value } for detail panel with copy buttons */
export function flattenContactFields(submission) {
  return [
    { label: 'Source', value: CONTACT_SOURCE_LABELS[submission.source] || submission.source },
    { label: 'Name', value: submission.name },
    { label: 'Email', value: submission.email },
    { label: 'Phone', value: submission.phone },
    { label: 'Subject', value: submission.subject },
    { label: 'Message', value: submission.message },
    { label: 'Language', value: LANGUAGE_LABELS[submission.language] || submission.language },
  ]
}
